import { render, staticRenderFns } from "./FilterSaveLoad.vue?vue&type=template&id=0131a8a6&scoped=true"
import script from "./FilterSaveLoad.vue?vue&type=script&lang=js"
export * from "./FilterSaveLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131a8a6",
  null
  
)

export default component.exports